import styled from 'styled-components';

export const EnergyConsumptionGoalContainer = styled.div`
  margin-top: 32px;
  display: flex;
`;
